import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaSmile,
  FaShoppingCart,
  FaMobileAlt,
  FaEye,
  FaRocket,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const UserFriendlyEcommerceWebsiteDesignInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="User-Friendly E-commerce Website Design in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Shop with Ease</Subheading>}
        heading={
          <Heading>
            User-Friendly{" "}
            <span tw="text-primary-500">E-commerce Website Design</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in user-friendly e-commerce website
            design in **Bur Dubai**, creating intuitive, engaging online stores
            that delight customers and drive sales. Transform your business with
            a design that’s easy to navigate and built for success.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1616469829581-73993eb86b02?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Design Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="User-Friendly Designs in Bur Dubai"
        description="We craft e-commerce websites that prioritize customer satisfaction."
        cards={[
          {
            icon: <FaSmile color="#ff5464" size={40} />,
            title: "Intuitive Navigation",
            description: "Easy-to-use menus and layouts for all users.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Seamless Checkout",
            description: "Streamlined process to boost conversions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-First Design",
            description: "Optimized for shopping on any device.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Visually Appealing",
            description: "Attractive designs that enhance brand appeal.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Performance",
            description: "Quick-loading pages for a smooth experience.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Success",
            description: "Trusted by Bur Dubai businesses for usability.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Design Process for User-Friendly Stores"
        description={
          <Description>
            We create user-friendly e-commerce websites with a customer-centric
            approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Understand your audience and goals.</li>
              <li>Design: Craft intuitive, visually stunning layouts.</li>
              <li>Development: Build responsive, easy-to-use features.</li>
              <li>Testing: Ensure usability across devices and users.</li>
              <li>Launch: Deploy a store that customers love.</li>
              <li>Support: Refine based on feedback and trends.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1661956602116-aa6865609028?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2564&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="User-Friendly Success in Bur Dubai"
        description="Our designs have elevated local e-commerce experiences."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Conversion Boost",
            description: "Increased sales by 160% with intuitive design.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Success",
            description: "75% of traffic from mobile users retained.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Feedback",
            description: "95% satisfaction for usability and design.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Better Store?</Subheading>}
        heading="User-Friendly E-commerce in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for user-friendly e-commerce website
            design in Bur Dubai. Create an online store that’s simple, stunning,
            and successful—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1621274147744-cfb5032c9d77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1633876841157-78c12e53f35a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
